module.exports = __webpack_public_path__ + "img/hand_side3_46.ff3b16f0.svg";